<template>
    <span class="form-required">*</span>
</template>

<script>
export default {
    name: "RequiredField"
}
</script>

<style scoped>
.form-required{
    color: #d03131;
}
</style>
